import * as _ from "lodash";

// ClickUp 1248h539kqa - dm-kiosk-app-create-order-new stamps every kiosk order
// with kiosk: true. A kiosk order is listed here only because the customer
// signed in at the kiosk with their account. It is paid at the kiosk or at the
// cashier, so no payment button or flow of this app may act on it.
export function isKioskOrder(order: any): boolean {
  return !!order && order.kiosk === true;
}

// The pre_cash payment info picks "the latest order". It is picked among this
// app's own orders, so a newer kiosk order neither opens that flow nor takes
// the place of one of this app's orders in it.
export function getLatestNonKioskOrder(orders: any): any {
  return _.first(
    _.orderBy(
      _.filter(_.cloneDeep(orders), (order) => !isKioskOrder(order)),
      ["timestamp"],
      ["desc"]
    )
  );
}

// mo_users_renew_token sends the orders that seed the pending orders without
// the kiosk flag. Such an order is recognised by matching an order that
// carries the flag, such as the kiosk_orders of the same renew_token event.
export function isKnownKioskOrder(order: any, flaggedOrders: any): boolean {
  return (
    isKioskOrder(order) ||
    (!!order &&
      _.some(
        flaggedOrders,
        (flaggedOrder) =>
          isKioskOrder(flaggedOrder) &&
          String(flaggedOrder.order_id) === String(order.order_id) &&
          String(flaggedOrder.store_id) === String(order.store_id)
      ))
  );
}
